/**
 * Created by laugh on 10/15/2017.
 */


export default function (state = "", action) {

    switch (action.type) {
        case 'SET_CUSTOMER':
            return action
        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/reducers/set-customer.js